import { requireField } from './validators';

export default class PoliceEvent {
  constructor(data = {}) {
    requireField(data.type, 'police.type');
    requireField(data.severity, 'police.severity');
    requireField(data.status, 'police.status');
    requireField(data.date, 'police.date');

    this.id = data.id || `pol-${Math.random().toString(36).slice(2, 9)}`;
    this.category = data.category || 'Police';
    this.type = data.type;
    this.severity = data.severity;
    this.status = data.status;
    this.description = data.description || '';
    this.date = data.date;
    this.assignedOwner = data.assignedOwner || '';
    this.reviewDate = data.reviewDate || null;
    this.escalationLevel = data.escalationLevel || 'L1';
    this.attachments = data.attachments || [];
    this.createdBy = data.createdBy || 'System';
    this.createdAt = data.createdAt || new Date().toISOString();
    this.updatedAt = data.updatedAt || this.createdAt;
    this.visibility = data.visibility || ['Admin', 'Manager'];
  }

  toJSON() {
    return { ...this };
  }
}
